import React from 'react';
import {Form, Formik, Field} from 'formik';
import {Alert, Button, FormGroup, Label} from 'reactstrap';
import * as Yup from 'yup';

import {useUserDispatch} from 'contexts/user';
import {submitForm} from 'utils/forms';
import CustomInputField from '../../../components/CustomInputField';
import track, {identify} from 'utils/track';
import {useFetchUuid} from 'hooks/useFetchUuid';

const {SF_API_URL} = process.env;
const {QUIZ_OPTIN_FORM_ID} = process.env;
const {SITE_ID} = process.env;

const SignupSchema = Yup.object().shape({
  firstname: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email').required('Required')
});

export default function QuizContactForm({onSubmit = undefined, onComplete = () => {}}) {
  const userDispatch = useUserDispatch();
  const fetchUuid = useFetchUuid(SF_API_URL);
  return (
    <>
      <div className="optin-wrap mb-3">
        <Formik
          initialValues={{
            email: '',
            firstname: ''
          }}
          validationSchema={SignupSchema}
          onSubmit={(values, actions) => {
            onSubmit(values, actions);
            return submitForm({firstName: values.firstname, email: values.email}, QUIZ_OPTIN_FORM_ID)
              .then(({data}) => {
                // fetchUuid resolves after a delay, so SET_USER below will always run first
                fetchUuid(values.email, data.proxy_data.mc_contact_uuid)
                  .then((uuid) => {
                    if (!uuid) return;
                    identify(uuid, {
                      uuid,
                      firstName: values.firstName,
                      email: values.email
                    });
                    userDispatch({type: 'UPDATE_USER', payload: {uuid}});
                  })
                  .catch((err) => console.error(err));
                return userDispatch({
                  type: 'SET_USER',
                  payload: {
                    firstName: values.firstName,
                    email: values.email,
                    quizRegistrationId: data.proxy_data.registrationId
                  }
                });
              })
              .then(() =>
                track('User Registered', {
                  property: SITE_ID,
                  entryPoint: 'Quiz',
                  label: `${SITE_ID} - Quiz`
                })
              )
              .then(() => onComplete())
              .catch((e) => {
                actions.setStatus({error: e});
                actions.setSubmitting(false);
              });
          }}
          render={({values, handleSubmit, isSubmitting, isValid, status}) => (
            <Form onSubmit={handleSubmit}>
              {status && status.error && <Alert color="danger">{status.error}</Alert>}
              <FormGroup>
                <Label for="firstname" hidden>
                  First Name
                </Label>
                <Field
                  name="firstname"
                  type={'text'}
                  component={CustomInputField}
                  placeholder="What is your first name?"
                  bsSize="lg"
                />
              </FormGroup>
              <FormGroup>
                <Label for="email" hidden>
                  Email
                </Label>
                <Field
                  name="email"
                  type={'email'}
                  component={CustomInputField}
                  placeholder="What is your best email?"
                  bsSize="lg"
                />
              </FormGroup>

              <Button className="btn-cta-block" color="cta" type="submit" disabled={isSubmitting || !isValid} block>
                {isSubmitting ? (
                  'Loading...'
                ) : (
                  <>
                    Take the quiz <br className="d-sm-none d-lg-block" />
                    and find out now
                  </>
                )}
              </Button>
            </Form>
          )}
        />
      </div>

      <p className="text-small text-left mb-0">
        By entering your information here, you are agreeing to receive messages from Food Revolution Network and Team
        Sherzai. Your email address will NEVER be shared or sold. You are always free to easily unsubscribe at any time.
        See our{' '}
        <a className="text-underline" href="https://foodrevolution.org/privacy-policy/" target="_blank">
          Privacy Policy
        </a>{' '}
        for more info.
      </p>
    </>
  );
}
